(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/overview/overview-dimmer.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/overview/overview-dimmer.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  useRef,
  useEffect
} = React;
const OverviewDimmer = () => {
  const isOverviewOpen = useSelector(state => state.isOverviewOpen);
  const dimmerRef = useRef();
  useEffect(() => {
    if (svs.core.detect.formfactor.desktop()) {
      if (isOverviewOpen) {
        dimmerRef.current.classList.add('challenge-overview-dimmer-visible');
      } else {
        dimmerRef.current.classList.remove('challenge-overview-dimmer-visible');
      }
    }
  }, [isOverviewOpen]);
  return React.createElement("div", {
    className: "challenge-overview-dimmer",
    ref: dimmerRef
  });
};
setGlobal('svs.challenge.OverviewDimmer', OverviewDimmer);

 })(window);